import * as React from "react";
import type { SVGProps } from "react";
const SvgReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#receipt_svg__a)">
      <path d="M14 22a1 1 0 0 1-.71-.29L12 20.41l-1.29 1.3a1 1 0 0 1-1.42 0l-1.42-1.42-2.32 1.54a1 1 0 0 1-1 .05A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-.53.88 1 1 0 0 1-1-.05l-2.32-1.54-1.42 1.42A1 1 0 0 1 14 22m-2-4a1 1 0 0 1 .71.29l1.29 1.3 1.29-1.3a1 1 0 0 1 1.26-.12l1.45 1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.13l1.45-1a1 1 0 0 1 1.26.12l1.29 1.3 1.29-1.3A1 1 0 0 1 12 18" />
      <path d="M12.53 16.28a4 4 0 0 1-3-1.42 5.21 5.21 0 0 1-.06-6.65 4 4 0 0 1 3-1.49 4 4 0 0 1 3.06 1.42 1 1 0 0 1-.1 1.41A1 1 0 0 1 14 9.46a2 2 0 0 0-1.51-.74A2 2 0 0 0 11 9.5a3.25 3.25 0 0 0 0 4 2 2 0 0 0 3 0 1 1 0 0 1 1.41-.09 1 1 0 0 1 .1 1.41 4 4 0 0 1-2.98 1.46" />
      <path d="M12.53 13.58H8.21a1 1 0 1 1 0-2h4.32a1 1 0 0 1 0 2m0-2.16H8.21a1 1 0 1 1 0-2h4.32a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="receipt_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReceipt;
